<template>
    <div class="echarts-block">
        <div class="tab-data left-center">
            <button
                :class="activeData === 1 ? 'is-active' : ''"
                @click="tabChange(1)"
            >
                成交数据
            </button>
            <button
                :class="activeData === 2 ? 'is-active' : ''"
                @click="tabChange(2)"
            >
                挂牌数据
            </button>
        </div>
        <div
            class="echarts-block-echarts-container"
            id="echarts-block-echarts-container"
            v-auto-size
        ></div>
        <div
            v-if="sbdLocId !== $route.params.id"
            class="earth"
            @click="handleBack"
            :title="backTitle"
        ></div>
        <div
            v-if="backMapTitle"
            class="earth map-back"
            @click="mapBack"
            :title="backMapTitle"
        ></div>
        <div class="trading-situation">
            <trading-situation ref="trading" />
        </div>
    </div>
</template>

<script>
import { getRelativelySize } from '@/utils/size'
import * as screenAPI from '@/api/screen'
import store from '@/utils/store'
import eventHub from '@/utils/eventHub'
import echartsAutoSwitchTooltip from '@/mixins/echartsAutoSwitchTooltip'
import { STORE_AREA_INFO_KEY } from '@/constans/common'
import TradingSituation from './TradingSituation'
import env from '@/config/env'

const turfCentroid = require('@turf/centroid').default

function getCentroid(geometry) {
    const cneter1 = turfCentroid(geometry).geometry.coordinates

    return cneter1
}

/**
 * 地图
 */
export default {
    mixins: [echartsAutoSwitchTooltip],
    components: {
        TradingSituation
    },
    echartsInstance: null,
    mapMappingList: null,
    currentMapInfo: null,
    currentMapEchartId: null,
    isInit: false,
    initMapInfo: null,
    data: function() {
        return {
            sbdLocId: env.SBDLOCIT,
            siteId: 0,
            backTitle: '',
            activeData: 1,
            backMapTitle: '',
            locDataList: []
        }
    },
    mounted() {
        this.siteId =
            this.$route.params.id === 'zhongguo' ? 0 : this.$route.params.id

        eventHub.$on('areaChange', () => {
            if (!this.isInit) {
                this.isInit = true
                this.getEachrtInfo()
            }
        })
        this.init()
        let arr = sessionStorage.getItem('list')
            ? JSON.parse(sessionStorage.getItem('list'))
            : []
        if (arr.length === 3) {
            this.backMapTitle = `查看 ${arr[1].echartLocName} 数据`
        } else if (arr.length === 2) {
            this.backMapTitle = `查看 ${arr[0].echartLocName} 数据`
        } else {
            this.backMapTitle = ''
        }
    },
    methods: {
        mapBack() {
            let arr = sessionStorage.getItem('list')
                ? JSON.parse(sessionStorage.getItem('list'))
                : []
            // 这里只处理了三级，加入中国后多了一级
            if (arr.length === 3) {
                if (this.$route.name === 'haiken') {
                    this.$router.push(
                        `/${arr[1].siteId}/haiken?backId=${arr[0].siteId}`
                    )
                } else {
                    this.$router.push(
                        '/' + arr[1].siteId + '?backId=' + arr[0].siteId
                    )
                }
                arr.splice(2, 1)
                sessionStorage.setItem('list', JSON.stringify(arr))
                location.reload()
            } else if (arr.length === 2) {
                if (this.$route.name === 'haiken') {
                    this.$router.push(`/${arr[0].siteId}/haiken`)
                } else {
                    if (!+arr[0].siteId) {
                        this.$router.push('/zhongguo')
                    } else {
                        this.$router.push('/' + arr[0].siteId)
                    }
                }
                sessionStorage.removeItem('list')
                location.reload()
            }
        },
        tabChange(val) {
            this.activeData = val

            eventHub.$emit('areaChange', { ctype: this.activeData })
            this.$nextTick(() => {
                this.setEchartOption()
            })
        },
        registerMap(name, json) {
            if (!echarts.getMap(name)) {
                echarts.registerMap(name, json)
            }
        },
        ceilNumber(num) {
            let integer = Math.ceil(num)
            let length = String(integer).length
            return (
                Math.ceil(integer / Math.pow(10, length - 1)) *
                Math.pow(10, length - 1)
            )
        },
        getOptions() {
            const _this = this

            const areaJSON = echarts.getMap(this.currentMapInfo.echartLocId)
                .geoJson
            const max =
                this.activeData === 1
                    ? Math.max.apply(
                          Math,
                          this.locDataList.map((o) => o.totalAmount)
                      )
                    : Math.max.apply(
                          Math,
                          this.locDataList.map((o) => o.totalArea)
                      )
            let integer = Math.ceil(max)
            let length = String(integer).length
            const finalMax =
                Math.ceil(integer / Math.pow(10, length - 1)) *
                    Math.pow(10, length - 1) || 300
            const that = this
            const options = {
                geo: {
                    show: true,
                    map: this.currentMapInfo.echartLocId,
                    aspectScale: 1,
                    zoom: 1.2,
                    itemStyle: {
                        normal: {
                            areaColor: 'rgba(0, 0, 0, 0)'
                        },
                        borderWidth: getRelativelySize(1),
                        borderColor: 'rgba(0,0,0,0)',
                        shadowBlur: getRelativelySize(10),
                        shadowColor: '#030B20',
                        shadowOffsetX: getRelativelySize(5),
                        shadowOffsetY: getRelativelySize(5)
                    }
                },
                visualMap: {
                    show: finalMax === -Infinity ? false : true,
                    type: 'continuous',
                    top: getRelativelySize(10),
                    left: 0,
                    itemHeight: getRelativelySize(100),
                    itemWidth: getRelativelySize(20),
                    textStyle: {
                        color: '#fff',
                        width: 5,
                        overflow: 'truncate',
                        fontSize: 8
                    },
                    formatter: function(value) {
                        return (
                            value.toFixed(2) +
                            '\n' +
                            (that.activeData === 1 ? '万元' : '亩')
                        )
                    },
                    min: 0,
                    max: finalMax, //this.ceilNumber(max),
                    text: ['HIGH', 'LOW'],
                    realtime: true,
                    // hoverLink: false,
                    calculable: true,
                    inRange: {
                        color: ['#3E69F8', '#30A8F4', '#44ccbc']
                    }
                },
                series: [
                    {
                        type: 'map',
                        map: this.currentMapInfo.echartLocId,
                        aspectScale: 1,
                        zoom: 1.2,
                        itemStyle: {
                            areaColor: '#005AA3',
                            borderWidth: getRelativelySize(1),
                            borderType: 'solid',
                            borderColor: '#33A7ef'
                        },
                        label: {
                            show: true,
                            color: '#fff',
                            fontSize:
                                _this.sbdLocId !== _this.$route.params.id
                                    ? 10
                                    : 14,
                            lineHeight: 14,
                            formatter: function(params) {
                                if (_this.sbdLocId !== _this.$route.params.id) {
                                    let name = ''
                                    if (params.data.name.length >= 6) {
                                        name =
                                            params.data.name.slice(
                                                0,
                                                params.data.name.length / 2
                                            ) +
                                            '\n' +
                                            params.data.name.slice(
                                                params.data.name.length / 2,
                                                params.data.name.length
                                            )
                                    } else {
                                        name = params.data.name
                                    }
                                    return name
                                } else {
                                    return params.data.name
                                }
                            }
                        },
                        emphasis: {
                            label: {
                                show: true,
                                color: '#333'
                            },
                            itemStyle: {
                                // areaColor: '#51B6EC'
                                areaColor: '#ecd271',
                                borderColor: '#1e72cf',
                                borderWidth: getRelativelySize(3)
                            }
                        },
                        data: areaJSON.features.map((fe) => {
                            const name = fe.properties.name
                            const center = getCentroid(fe)
                            const symbolConfig = {}
                            const exist = this.locDataList.find(
                                (i) => i.locCode == fe.properties.id
                            )

                            return {
                                name: name,
                                center: center,
                                value:
                                    this.activeData === 1
                                        ? (exist && exist.totalAmount) || 0
                                        : (exist && exist.totalArea) || 0,
                                ...symbolConfig,
                                highStandardFarmlandArea:
                                    (exist && exist.highStandardFarmlandArea) ||
                                    0,
                                totalAmount: (exist && exist.totalAmount) || 0,
                                totalArea: (exist && exist.totalArea) || 0,
                                totalNumber:
                                    (exist &&
                                        exist.totalNumber &&
                                        parseInt(exist.totalNumber)) ||
                                    0
                            }
                        })
                    }
                ]
            }
            if (this.activeData === 1) {
                options.tooltip = {
                    padding: [
                        getRelativelySize(8),
                        getRelativelySize(12),
                        getRelativelySize(8),
                        getRelativelySize(12)
                    ],
                    textStyle: {
                        fontSize: 8
                    },
                    backgroundColor: 'rgba(30,31,46,0.80)',
                    borderWidth: getRelativelySize(1),
                    borderColor: 'rgba(15,128,252,0.22)',
                    extraCssText: 'box-shadow: 0 0 8px 2px rgba(0,57,119,0.50)',
                    formatter: function(params) {
                        if (params.data !== undefined) {
                            return `<div class="map__tip"><p>累计成交额：<span>${params
                                .data.totalAmount || 0}</span>${
                                !_this.siteId ? '亿元' : '万元'
                            }</p><p>累计成交笔数：<span>${params.data
                                .totalNumber || 0}</span>笔</p>${
                                params.data.highStandardFarmlandArea > 0
                                    ? `<p>高标准农田建设面积：<span>${params
                                          .data.highStandardFarmlandArea ||
                                          0}</span>（亩）</p>`
                                    : ''
                            }</div>`
                        }
                    }
                }
            } else if (this.activeData === 2) {
                options.tooltip = {
                    padding: [
                        getRelativelySize(8),
                        getRelativelySize(12),
                        getRelativelySize(8),
                        getRelativelySize(12)
                    ],
                    textStyle: {
                        fontSize: 8
                    },
                    backgroundColor: 'rgba(30,31,46,0.80)',
                    borderWidth: getRelativelySize(1),
                    borderColor: 'rgba(15,128,252,0.22)',
                    extraCssText: 'box-shadow: 0 0 8px 2px rgba(0,57,119,0.50)',
                    formatter: function(params) {
                        if (params.data !== undefined)
                            return `<div class="map__tip"><p>挂牌面积：<span>${params
                                .data.totalArea ||
                                0}</span>（亩）</p><p>挂牌数量：<span>${params
                                .data.totalNumber || 0}</span>笔</p>${
                                params.data.highStandardFarmlandArea > 0
                                    ? `<p>高标准农田建设面积：<span>${params
                                          .data.highStandardFarmlandArea ||
                                          0}</span>（亩）</p>`
                                    : ''
                            }</div>`
                    }
                }
            }
            return options
        },
        async setEchartOption() {
            const data = await screenAPI.getMapLocData({
                siteId: this.siteId, // 站点id
                summaryType: this.activeData === 1 ? 1 : 2, // 统计类型 1交易 2挂牌
                resource: this.$route.name === 'haiken' ? 2 : 1 // 屏幕参数[1:产权 ,2:海垦]
            })
            if (data.code == 200) {
                this.locDataList = data.data
            }
            const options = this.getOptions()
            const areaJSON = echarts.getMap(this.currentMapInfo.echartLocId)
                .geoJson
            const len = (areaJSON.features && areaJSON.features.length) || 0
            this.echartsInstance.setOption(options, true)
            this.echartsAutoSwitchTooltip({
                echartsToolTipLen: len,
                echartsToolTipAutoPlayInterval: 3000
            })
        },
        fnThrottle(method, delay, duration) {
            var that = this
            var timer = that.timer
            var begin = new Date().getTime()
            return function(...args) {
                var current = new Date().getTime()
                clearTimeout(timer)
                if (current - begin >= duration) {
                    method()
                    begin = current
                } else {
                    that.timer = setTimeout(function() {
                        method.apply(that, args)
                    }, delay)
                }
            }
        },
        init() {
            if (this.echartsInstance) return
            const charInstance = echarts.init(
                document.getElementById('echarts-block-echarts-container')
            )
            charInstance.on('click', (e) => this.handleMapClick(e))
            charInstance.on('mouseOver', (e) => {
                // 魏都区 map json 中存在，但 siteLocList 接口中不存在的地区无需任何交互
                if (env.WDQLOCID === this.siteId) {
                    const filterName = this.mapMappingList.map((item) => {
                        return item.aliasName
                    })
                    if (!filterName.includes(e.data.name)) {
                        charInstance.dispatchAction({
                            type: 'downplay',
                            seriesIndex: e.seriesIndex,
                            dataIndex: e.dataIndex
                        })
                    }
                }
                e.innerHTML = ''
            })
            this.echartsInstance = charInstance
        },
        async handleMapClick(params) {
            const { name } = params
            // 根据名字在地图信息中查找对应的 id
            let features = echarts.getMap(this.currentMapInfo.echartLocId)
                .geoJson.features
            let echartId = null

            for (let i = 0; i < features.length; i++) {
                if (features[i].properties.name === name) {
                    echartId = features[i].properties.id
                    break
                }
            }

            if (echartId) {
                const currentMapInfo = this.findAreaInfoByKey(echartId)

                if (currentMapInfo) {
                    if (currentMapInfo.level < 4 && currentMapInfo.siteId) {
                        try {
                            const responseJSON = await screenAPI.getMapJSON(
                                currentMapInfo.echartLocId
                            )
                            if (
                                responseJSON.status === 200 &&
                                responseJSON.data.features &&
                                responseJSON.data.features.length
                            ) {
                                let arr = sessionStorage.getItem('list')
                                    ? JSON.parse(sessionStorage.getItem('list'))
                                    : []
                                if (arr.length === 0) {
                                    this.initMapInfo.siteId = this.siteId
                                    arr[0] = this.initMapInfo
                                    arr[1] = currentMapInfo
                                } else if (arr.length === 2) {
                                    arr[2] = currentMapInfo
                                }
                                sessionStorage.setItem(
                                    'list',
                                    JSON.stringify(arr)
                                )
                                if (this.$route.name === 'haiken') {
                                    this.$router.push(
                                        `/${currentMapInfo.siteId}/haiken?backId=${this.siteId}`
                                    )
                                } else {
                                    this.$router.push(
                                        '/' +
                                            currentMapInfo.siteId +
                                            '?backId=' +
                                            this.siteId
                                    )
                                }
                                location.reload()
                            } else {
                                this.triggerChange(currentMapInfo, params)
                            }
                        } catch (e) {
                            this.triggerChange(currentMapInfo, params)
                        }
                    } else {
                        if (!this.siteId) {
                            return false
                        } else {
                            this.triggerChange(currentMapInfo, params)
                        }
                    }
                } else {
                    console.error(`未找到 ${name} ${echartId} 信息。`)
                }
            } else {
                console.error(`未找到映射关系: ${name}`)
            }
        },
        handleBack() {
            // 当前选中不是初始地图则显示初始数据
            if (this.currentMapEchartId !== this.initMapInfo.echartLocId) {
                this.initMapInfo.tid = ''
                // 因接口可能多个项目使用了，所以前端写死
                if (!this.siteId) {
                    this.initMapInfo.aliasName = '全国'
                    this.initMapInfo.echartLocName = '全国'
                }

                this.triggerChange(this.initMapInfo, null)
            }
        },
        triggerChange(currentMapInfo, params) {
            // 修改标题
            if (currentMapInfo.aliasName) {
                eventHub.$emit('titleChange', currentMapInfo.aliasName)
            }
            this.currentMapEchartId = currentMapInfo.echartLocId

            const options = this.getOptions()
            this.echartsInstance.setOption(options)
            if (params) {
                this.echartsInstance.dispatchAction({
                    type: 'downplay',
                    seriesIndex: 0
                })
                this.echartsInstance.dispatchAction({
                    type: 'highlight',
                    seriesIndex: 0,
                    dataIndex: params.dataIndex
                })
            }

            // 注意，这里做了一个字段重命名，
            // 因为前台使用的是 tuLiuLocId 作为名字，实际上是用的 tid 的值
            store.setValue(
                STORE_AREA_INFO_KEY,
                Object.assign({}, currentMapInfo, {
                    tuLiuLocId: currentMapInfo.tid
                })
            )
            eventHub.$emit('areaChange', { ctype: this.activeData })
        },
        /**
         * 查找地区信息
         * @param id {string|number} echartLocId 或者 tuLiuLocId，
         * @param isTid {boolean} 是否是 tid，默认 false
         */
        findAreaInfoByKey(id, isTid) {
            for (let i = 0; i < this.mapMappingList.length; i++) {
                const item = this.mapMappingList[i]
                if (isTid) {
                    if (+item.tid === +id) {
                        return item
                    }
                    return item
                } else {
                    if (+item.echartLocId === +id) {
                        return item
                    }
                }
            }

            return null
        },
        /**
         * 地图地区名称新增简称显示
         * @param mapJSON {arr}，
         */
        replaceName(mapJSON) {
            for (let i = 0; i < mapJSON.features.length; i++) {
                for (let j = 0; j < this.mapMappingList.length; j++) {
                    if (
                        mapJSON.features[i].properties.id ===
                        this.mapMappingList[j].echartLocId
                    ) {
                        mapJSON.features[i].properties.name = this
                            .mapMappingList[j].aliasName
                            ? this.mapMappingList[j].aliasName
                            : this.mapMappingList[j].echartLocName
                    }
                }
            }
            return mapJSON
        },
        /**
         * 获取地图信息
         */
        async getEachrtInfo() {
            const tuLiuLocId = store.getValue(STORE_AREA_INFO_KEY).tuLiuLocId
            const params = {
                siteId: this.siteId
            }
            const response = await screenAPI.siteLocList(params)
            // levelChange 地图 县、区  竞拍项目和预挂牌项目列表不展示 地区字段
            eventHub.$emit('levelChange', response.data[0].level || '')
            let arr = response.data ? response.data : []
            let newArr = []
            for (let i = 0; i < arr.length; i++) {
                let obj = {
                    id: arr[i].siteId,
                    tid: arr[i].tid,
                    aliasName: arr[i].aliasName,
                    levelType: arr[i].levelType,
                    tuLiuLocId: arr[i].tuLiuLocId,
                    echartLocId: arr[i].code,
                    echartLocName: arr[i].name,
                    level: arr[i].level,
                    siteId: arr[i].siteId,
                    transferArea: '6213.37'
                }
                newArr.push(obj)
            }
            store.setValue(STORE_AREA_INFO_KEY, {
                tuLiuLocId: this.siteId,
                tid: newArr[0].tid
            })
            // 监听当前站点区域id
            // eventHub.$emit('areaCodeChange', newArr[0].tid)

            this.mapMappingList = newArr

            const info = (this.currentMapInfo = this.findAreaInfoByKey(
                tuLiuLocId,
                true
            ))
            const errorHandle = () => {
                console.error(`请求 JSON错误: ${info.echartLocId}`)
            }

            if (info) {
                this.initMapInfo = info

                if (info.aliasName) {
                    // 修改文档标题
                    eventHub.$emit(
                        'titleChange',
                        !this.siteId ? '全国' : info.aliasName
                    )

                    // 设置返回按钮标题
                    this.backTitle = `查看 ${
                        !this.siteId ? '全国' : info.aliasName
                    } 数据`
                }

                try {
                    /**
                     * 拉取地图 JSON 数据进行地图渲染
                     */
                    const responseJSON = await screenAPI.getMapJSON(
                        info.echartLocId
                    )

                    if (responseJSON.status === 200) {
                        const mapJSON = responseJSON.data
                        this.registerMap(
                            info.echartLocId,
                            this.replaceName(mapJSON)
                        )
                        // const options = this.getOptions()
                        // this.echartsInstance.setOption(options)
                        this.setEchartOption()
                    } else {
                        errorHandle()
                    }
                } catch (e) {
                    errorHandle()
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.echarts-block {
    height: 652px;
    /*background-size: 100% 100%;*/
    /*background-repeat: no-repeat;*/
    /*background-image: url('../../../assets/images/echarts_block_bg@2x.png');*/
    position: relative;
    .tab-data {
        padding: 10px 0;
        button {
            border: 0 solid #33a7f0;
            box-shadow: 0 0 3px 2px rgba(70, 102, 255, 0.5);
            font-size: 15.12px;
            line-height: 16px;
            color: #33a7f0;
            outline: none;
            background: none;
            padding: 10px 70px;
            cursor: pointer;
            position: relative;
            &.is-active {
                color: #ffffff;
                background: #33a7f0;
                box-shadow: 0 0 3px 2px rgba(70, 102, 255, 0.5);
            }
        }
    }
    .echarts-block-echarts-container {
        width: 100%;
        height: 480px;
    }
    .trading-situation {
        width: 100%;
    }
    > .earth {
        width: 45px;
        height: 63px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url('../../../assets/images/earth@2x.png');
        position: absolute;
        top: 20px;
        right: 21px;
        cursor: pointer;
        &.map-back {
            height: 45px;
            background-image: url('../../../assets/images/back.png');
            left: 20px;
        }
    }
}
::v-deep {
    .map__tip {
        p {
            span {
                color: #f9b236;
                font-weight: 600;
                margin-right: 5px;
                text-shadow: 0 2px 2px rgba(31, 24, 19, 0.6);
            }
        }
    }
}
</style>
